module.exports = __webpack_public_path__ + "static/sunburst-mobile-45d0f588ef0a1fbb778c02357d70320d.png";